module.exports = __webpack_public_path__ + "static/media/bichiii-feli.03eaae2b.png";